import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_5 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "card-body py-3" }

import { textSearch } from "@/assets/ts/_utils";
import JsonExcel from "@/components/widgets/tables/JsonExcel.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { SortProps, sortFn } from "@/core/helpers/sort";
import Page from "@/layout/Page.vue";
import { AuthModule, UsuariosListadoModule } from "@/store/modules";
import Swal from "sweetalert2";
import { computed, onActivated, onBeforeMount, onMounted, ref } from "vue";
import { useArrayPagination } from "vue-composable";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";


import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "personal-listado",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const store = useStore();
const module = getModule(UsuariosListadoModule, store);
const authModule = getModule(AuthModule, store);
const isAdmin = !authModule.user.comarcaId;

const usuarios = computed(() =>
  module.usuarios.map((u) => {
    return {
      ...u,
      nombreComarca: (u.comarcas ?? []).map((c) => c.nombre).join(", "),
      notificacionesValue: u.notificaciones ? t("general.si") : t("general.no"),
    };
  })
);

// Exportar a Excel.
const csvLabels = {
  nombre: t("csv.listados.personal.nombre"),
  nombreComarca: t("csv.solicitudes.familias.comarca"),
  email: t("csv.listados.personal.email"),
};
const csvFields = Object.keys(csvLabels);
const csvName = "personalListado" + new Date().getTime() + ".xlsx";

// Busqueda y ordenación.
const search = ref("");
const sortProps = ref<SortProps>({
  prop: "createdOn",
  order: "descending",
  method: null,
});
const sortChange = ({ column, prop, order }) => {
  sortProps.value = { prop, order, method: column.sortMethod };
};
const filteredCollection = computed(() =>
  usuarios.value
    .slice()
    .sort(sortFn(sortProps))
    .filter((data) => {
      return (
        !search.value ||
        textSearch(data.nombre, search.value) ||
        textSearch(data.email, search.value)
      );
    })
);

// Paginación.
const { result, currentPage } = useArrayPagination(filteredCollection, {
  pageSize: 100,
});
const handleCurrentPageChange = (page: number) => (currentPage.value = page);

const cargaListado = ref(false);
const load = async () => {
  cargaListado.value = true;
  try {
    await module.fetchAll();
    search.value = "";
    currentPage.value = 1;
  } catch (error) {
    Swal.fire({
      text: t("formularios.personalListado.cargar.error"),
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  } finally {
    cargaListado.value = false;
  }
};

const crearNuevo = () => {
  router.push("personal/nuevo");
};
const handleEdit = (index, row) => {
  router.push(`personal/${row.id}`);
};

onBeforeMount(() => {
  load();
});
onActivated(async () => {
  cargaListado.value = true;
  try {
    await module.fetchAll();
  } catch (error) {
    Swal.fire({
      text: t("formularios.personalListado.cargar.error"),
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  } finally {
    cargaListado.value = false;
  }
});
onMounted(() =>
  setCurrentPageBreadcrumbs(t("menu.usuariosListado"), [t("menu.usuarios")])
);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(Page, null, {
    actions: _withCtx(() => [
      isAdmin
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: crearNuevo
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("tabla.serviciosProgramadosListado.crear.boton")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("tabla.personalListado.titulo")), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("tabla.personalListado.numero", { numero: _unref(usuarios).length })), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_input, {
              modelValue: search.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              style: {"width":"300px"},
              placeholder: _ctx.$t('tabla.buscador.placeholder')
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(JsonExcel, {
              data: _unref(usuarios),
              labels: csvLabels,
              fields: _unref(csvFields),
              name: csvName
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_7, [
                  _createElementVNode("i", {
                    class: "fas fa-file-excel fs-3",
                    title: _ctx.$t('tabla.profesionalesListado.boton.imprimir')
                  }, null, 8, _hoisted_8)
                ])
              ]),
              _: 1
            }, 8, ["data", "fields"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: _unref(result),
            style: {"width":"100%"},
            stripe: "",
            "default-sort": { prop: 'createdOn', order: 'descending' },
            onSortChange: sortChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.personal.cabecera.comarca'),
                prop: "nombreComarca",
                sortable: "",
                "min-width": "150"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.personal.cabecera.nombre'),
                prop: "nombre",
                sortable: "",
                "min-width": "150"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.personal.cabecera.email'),
                prop: "email",
                sortable: "",
                "min-width": "150"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.personal.cabecera.notificaciones'),
                prop: "notificacionesValue",
                sortable: "",
                "min-width": "150"
              }, null, 8, ["label"]),
              isAdmin
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    width: "50",
                    fixed: "right"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "text",
                        onClick: ($event: any) => (handleEdit(scope.$index, scope.row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("tabla.profesionalesListado.fila.ver")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, cargaListado.value]
          ]),
          _createVNode(_component_el_pagination, {
            class: "my-5 float-end",
            background: "",
            "page-size": 100,
            layout: "prev, pager, next",
            total: _unref(usuarios).length,
            "hide-on-single-page": true,
            "current-page": _unref(currentPage),
            onCurrentChange: handleCurrentPageChange
          }, null, 8, ["total", "current-page"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})